"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateTokenSet = void 0;
var param_case_1 = require("param-case");
var functions_1 = require("../functions");
var utils_1 = require("../utils");
var getNormalizedValue = function (value) {
    if (Array.isArray(value)) {
        return value.map(function (val) { return val.origin; });
    }
    if (typeof value === 'object') {
        return value.origin;
    }
    return value;
};
var generateShadowTokenValue = function (_a) {
    var value = _a.value, type = _a.type, name = _a.name, withPrefixDesign = _a.withPrefixDesign;
    if (type !== 'css') {
        return '';
    }
    if (!Array.isArray(value)) {
        return value;
    }
    var newValue = (0, utils_1.getBoxShadow)(value);
    return newValue.map(function (val) { return (0, functions_1.toCSSVarTokenWithValue)("".concat((0, param_case_1.paramCase)(name)), val, withPrefixDesign); }).join(', ');
};
var generateTokenValue = function (_a) {
    var value = _a.value, type = _a.type, name = _a.name, withPrefixDesign = _a.withPrefixDesign;
    if (type !== 'css' ||
        (typeof value !== 'string' && !(typeof value === 'object' && 'origin' in value) && !Array.isArray(value))) {
        return value;
    }
    var newValue = getNormalizedValue(value);
    if (Array.isArray(newValue)) {
        return newValue.map(function (val) { return (0, functions_1.toCSSVarTokenWithValue)("".concat((0, param_case_1.paramCase)(name)), val, withPrefixDesign); }).join(', ');
    }
    return (0, functions_1.toCSSVarTokenWithValue)("".concat((0, param_case_1.paramCase)(name)), newValue, withPrefixDesign);
};
var generateMethodsMap = {
    color: generateTokenValue,
    shadow: generateShadowTokenValue,
    borderRadius: generateTokenValue,
    spacing: generateTokenValue,
};
var generateToken = function (_a) {
    var token = _a.token, type = _a.type, name = _a.name, mode = _a.mode;
    var withPrefixDesign = false;
    var comment = token.comment, value = token.value;
    var out = comment ? "/** ".concat(comment, " */\n") : '';
    // Для случаев, когда у токена есть префикс
    var clearName = name.split('-')[1] || name;
    var newValue = generateMethodsMap[mode]({ value: value, type: type, name: name, withPrefixDesign: withPrefixDesign });
    return "".concat(out, "export const ").concat(clearName, " = '").concat(newValue, "';\n");
};
/**
 * Преобразует объект токенов в CSS Properties object.
 * @param {TokenDataGroup<TokenType>} tokens Объект токенов
 * @param {GeneratedTokenType} type Тип выводимого токена
 * @param {string} name Имя токена
 * @param {GeneratedTokenMode} mode Вид выводимого токена
 * @return {string}
 */
var generateTokenSet = function (_a) {
    var tokens = _a.tokens, type = _a.type, mode = _a.mode;
    return Object.entries(tokens || {}).reduce(function (acc, _a) {
        var name = _a[0], token = _a[1];
        return "".concat(acc).concat(generateToken({ token: token, type: type, name: name, mode: mode }), "\n");
    }, '');
};
exports.generateTokenSet = generateTokenSet;
//# sourceMappingURL=generateTokenSet.js.map